/** Helpers de role — Fase 1 AVM Enterprise */

export const ROLES = {
  SUPER_ADMIN: "super_admin",
  ADMIN: "admin",
  ANALISTA: "analista",
  CLIENTE: "cliente"
};

export function isSuperAdmin(user) {
  return user?.role === ROLES.SUPER_ADMIN;
}

export function isAdmin(user) {
  return user?.role === ROLES.ADMIN;
}

/** Admin comum — não inclui super_admin (preserva comportamento UI admin) */
export function isAdminOnly(user) {
  return isAdmin(user);
}

/** Privilégios administrativos (admin + super_admin) */
export function isPrivilegedAdmin(user) {
  return isAdmin(user) || isSuperAdmin(user);
}

export function roleLabel(role) {
  const labels = {
    super_admin: "Super Admin",
    admin: "Administrador",
    analista: "Analista",
    cliente: "Cliente"
  };
  return labels[role] || role || "—";
}
